
import { Component, Vue, Prop } from "vue-property-decorator";
import Pop from "../../components/blue-pop.vue";
import { ExamVersionInfo } from "@/lib/model/exambuilder/exam-component/exam";
import InputNumberV3 from "@/views/ai-builder-v3/components/inputNumberV3.vue";
import IntroduceCard from "@/views/ai-builder-component/components/introduce-card.vue";
import HinaTextarea from "@/views/ai-builder-component/baseComponent/hina-textarea.vue";
import DialogForAddQuestion from "./DialogForAddQuestion.vue";
import QuestionLibDialog from "./QuestionLibDialog.vue";
import TtsConfigPop from "../../components/tts-config-pop.vue";

const RECOMMENDED_CODE = 1; // 推荐code
const USED_CODE = 1; // 已启用 code

@Component({
  components: {
    TtsConfigPop,
    Pop,
    InputNumberV3,
    HinaTextarea,
    IntroduceCard,
    DialogForAddQuestion,
    QuestionLibDialog
  }
})
export default class AiAnswer extends Vue {
  @Prop() formItemData!: ExamVersionInfo; // 组件数据
  @Prop({ default: "" }) builder!: string; // 创建面试来源

  NUM_USED = 1; // 是否开启 AI答疑官
  jsonString = "";
  get configData() {
    return this.formItemData.intelligentQa.configData;
  }
  TIPS_LIMITED = "长度不能超过240个字符";

  rules = {
    greetingFirstTime: [
      { required: true, message: "请输入首次见面欢迎语", trigger: "blur" },
      {
        min: 1,
        max: 240,
        message: this.TIPS_LIMITED,
        trigger: "blur"
      }
    ],
    greetingAgain: [
      { required: true, message: "请输入非首次见面欢迎语", trigger: "blur" },
      {
        min: 1,
        max: 240,
        message: this.TIPS_LIMITED,
        trigger: "blur"
      }
    ],
    responseSeveralMatches: [
      { required: true, message: "请输入命中多个问题话术", trigger: "blur" },
      {
        min: 1,
        max: 240,
        message: this.TIPS_LIMITED,
        trigger: "blur"
      }
    ],
    responseNoMatch: [
      { required: true, message: "请输入未命中多个问题话术", trigger: "blur" },
      {
        min: 1,
        max: 240,
        message: this.TIPS_LIMITED,
        trigger: "blur"
      }
    ]
  }; // 表单的校验规则
  dialogVisible = false; // 题库的弹窗，是否显示
  dialogVisibleForAdd = false; // 添加问题弹窗
  numSelected = 5;

  setVisibleForAdd(bool: boolean): void {
    this.dialogVisibleForAdd = bool;
  }

  setLinkAndLinkDetail(list) {
    // 更改detail
    this.configData.linkDetail.unshift(...list);
    // 更改link
    this.setLink();
  }

  // 得到添加的是哪些问题
  getList(list: any[]): void {
    // 添加要开启推荐
    const _list = list.map(ele => {
      return {
        ...ele,
        isRecommended: RECOMMENDED_CODE,
        status: USED_CODE
      };
    });
    this.setVisibleForAdd(false); // 弹窗消失
    this.setLinkAndLinkDetail(_list);
  }
  updateLinkDetail(newLinkDetail): void {
    this.$set(this.configData, "linkDetail", newLinkDetail); // 确保响应式
    this.setLink(); // 更改link
  }
  setLink() {
    const _link = this.configData.linkDetail.map(
      ({ qaId, id, isRecommended }) => {
        return {
          qaId: qaId || id,
          isRecommended
        };
      }
    );
    console.log("_link: ", _link);
    this.configData.link = _link;
  }

  beforeSetGlobal() {
    if (this.builder === "MOKA_V2") {
      this.$message.warning("请联系你的顾问开通后才可开启");
    }
  }

  setGlobal(): void {
    // 设置表单的回显与否
    // this.$emit("setGlobal");
  }

  setQuestionLib() {
    this.dialogVisible = true;
  }

  save() {
    try {
      JSON.parse(this.jsonString);
      this.formItemSubmit();
    } catch (e) {
      this.$message.error("录入JSON格式错误");
    }
  }

  formItemSubmit() {
    console.log("formItemSubmit: ", "asdf");
    this.$emit("formItemSubmit", {
      key: "intelligentQa",
      value: this.jsonString
    });
  }

  // 校验数据：
  formItemCheck() {
    const refs = this.$refs;
    return new Promise((resolve, reject) => {
      const txt = "AIAnswer";
      refs["formRef"].validate(valid => {
        if (valid) {
          resolve("");
        } else {
          console.log("error submit!!");
          resolve(txt);
        }
      });
    });
  }
}
